@if (authService.user$ | async; as user) {
  <div class="card-list">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title i18n>Angemeldet als</mat-card-title>
      </mat-card-header>
      <mat-card-content>{{ user.email }}</mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title i18n>Rollen</mat-card-title>
      </mat-card-header>
      <mat-card-content>{{ user.roles.join(', ') || '—' }}</mat-card-content>
    </mat-card>
  </div>
}

@if (authService.userHasRole('admin') | async) {
  <div class="card-list" *dtDataLoad="stats$ | async as stats">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title i18n>Registrierte Benutzer</mat-card-title>
      </mat-card-header>
      <mat-card-content>{{ stats.userCount }}</mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title i18n>Projekte</mat-card-title>
      </mat-card-header>
      <mat-card-content>{{ stats.projectCount }}</mat-card-content>
    </mat-card>
  </div>
}
